
import { Template, LazyTemplate } from "../../../core/template/index";
import { View } from "../../../core/view";

export default class TestStep03View extends View
{
    public template = Template.lazy('/views/testChain/step03/index.html');
}